import React, { useState, useEffect } from 'react';
import FieldValidity from '../../services/fieldValidity.service';
import FirebaseAnalytics from '../../services/analytics.service';
import Settings from '../../services/settings.service';
import Storage from '../../services/storage.service';
import Translations from '../../services/translation.service';
import User from '../../services/user.service';
import StorefrontTitle from '../shared/storefront-title.component';
import SpinnerTimeLoader from '../shared/timeLoading';
import OtpInput from '../shared/otp-screen/otpInputField';
import EligibilityService from '../../services/eligibility.service';
import moment from "moment";

const subscriptions = [];
const EligibilitySuccessOTP = (props) => {
    let prefix = "scr_3.3.4_otp_";
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [otpError, setOtpError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState({
        value: "",
        validations: {
            required: true,
            maxLength: 6,
            minLengthBool: 6
        },
        valid: false,
        touched: false,
    });
    useEffect(() => {
        Storage.set("eligibilityOTPloaded", true);
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
            Storage.clear("otpErrorStatus")
        }

    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const updateOtpField = (e) => {
        let validOTP = FieldValidity.checkFieldValidity(e.target.value, otp.validations);
        setOtp({
            ...otp,
            value: e.target.value,
            valid: validOTP,
            touched: true
        })
    }

    const handleOTPSubmit = () => {
        setOtpError(false);
        Storage.clear("otpErrorStatus");
        setLoading(true);
        const contact_number = props.phoneCode?.iso + props.phone?.value;
        let data = {
            name: "",
            contact_number: contact_number,
            otp: otp?.value
        }

        Storage.set("otpErrorStatus", true, true);
        User.submitContact(data)
            .then(response => {
                if (response && response?.data) {
                    Storage.clear("otpErrorStatus");

                    // Perform Eligibility Fufilment
                    if (props.is_post_paid) {
                        // Call API for Postpaid
                        const { 
                            firstName, 
                            lastName, 
                            birthDate, 
                            gender, 
                            maritalStatus, 
                            selectedNationalityId, 
                            selectedCityId,
                            phoneCode,
                            phone
                        } = props.state;
                        let data = {
                            date_of_birth: birthDate.value ? moment(birthDate.value).format('DD/MM/YYYY') : "",
                            first_name: firstName.value ? firstName.value : "",
                            last_name: lastName.value ? lastName.value : "",
                            gender: gender.value ? gender.value : "",
                            marital_status: maritalStatus.value ? maritalStatus.value : "",
                            nationality: selectedNationalityId ? selectedNationalityId : "",
                            phone_number: phone?.value ? phoneCode?.iso + phone?.value : "",
                            residence: selectedCityId ? selectedCityId : "",
                        }
                        EligibilityService.isEligibleForPostpaidPost(data)
                            .then((response) => {
                                if (response?.data?.IsEligible) {
                                    User.updateFlowStatus("IsEligible", true)
                                        .then(() => {
                                            props.action("EligibilitySuccess");
                                            props.toggleLoading(false);
                                            Storage.set("eligibility_fulfilled", true, true)
                                        })
                                        .catch(error => {
                                            props.toggleLoading(false);
                                        });
                                } else {
                                    props.action("EligibilityFailedPostpaid");
                                    props.toggleLoading(false);
                                }
                            })
                            .catch(error => {
                                props.toggleLoading(false);
                            });
                    } else {
                        User.updateFlowStatus("IsEligible", true)
                            .then(updateFlowStatusResponse => {
                                props.action("EligibilitySuccess");
                                props.toggleLoading(false);
                                Storage.set("eligibility_fulfilled", true, true)
                            })
                            .catch(error => {
                                props.toggleLoading(false);
                            });
                    }
                }
            })
            .catch(error => {
                setOtpError(true);
                Storage.clear("otpErrorStatus");
                setLoading(false)
            });
    }

    let mapStores = Settings?.footer?.get_map_stores;
    mapStores = mapStores.replace("%lang%", Translations.activeLang);
    return (
        <div className="activation-failed">
            <div>
                {loading ? <SpinnerTimeLoader /> :
                    <div>

                        <div className="otp-screen-wrapper">
                            <StorefrontTitle
                                title={translationKeys[prefix + "title_des"]}
                                desc={translationKeys[prefix + "message"]}
                            />
                            {props.loading ?
                                <SpinnerTimeLoader /> :
                                <>
                                    <OtpInput handleOtpForm={event => {
                                        const event1 = {
                                            target: {
                                                value: event
                                            }
                                        }
                                        if (FieldValidity.inputDigits(event1, 6)) {
                                            updateOtpField(event1);
                                        }
                                    }} />

                                    {otpError &&
                                        <>
                                            <div className="otp-not-valid">
                                                <p>
                                                    {translationKeys[prefix + "error_message"]}
                                                    {" "}{translationKeys[prefix + "or"]}{" "}
                                                    <a href={mapStores} rel="noopener noreferrer" target="_blank">
                                                        {translationKeys[prefix + "visit_our_nearest_store"]}
                                                    </a>
                                                </p>
                                            </div>
                                        </>}
                                    <div className="send-message">
                                        <p>{translationKeys["stm_otp_received"]}</p>
                                        <span onClick={() => {
                                            props.checkEligibilityRoot();
                                        }}>{translationKeys[prefix + "send_again"]}</span>
                                    </div>
                                    <button
                                        className="common-button"
                                        onClick={() => {
                                            FirebaseAnalytics.button_clicked(
                                                "stm_otp_continue");
                                            handleOTPSubmit()
                                        }}
                                        disabled={!otp.valid}
                                    >
                                        {translationKeys["stm_otp_continue"]}
                                    </button>
                                </>
                            }
                        </div>
                    </div>}
            </div>
        </div>
    )
}

export default EligibilitySuccessOTP;